import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

interface IMessages {
  header: string;
  subheader: string;
  buttonText: string;
  url: string;
}

@Component({
    selector: 'admin-generic-error-page',
    templateUrl: './generic-error-page.component.html',
    styleUrls: ['./generic-error-page.component.scss'],
    standalone: false
})
export class GenericErrorPageComponent implements OnDestroy {
  public errorStatusCode: number;
  public message: IMessages;

  private _destroy$ = new Subject();

  constructor(private _route: ActivatedRoute) {
    this._route.queryParams.pipe(takeUntil(this._destroy$)).subscribe(params => {
      this.message = this.getMessage(Number(params.errorStatusCode));
    });
  }

  getMessage(errorStatusCode: number): IMessages {
    if (errorStatusCode === 403) {
      return {
        header: 'You are not authorised to view this page.',
        subheader: "Let's get you back to safety.",
        buttonText: 'Go to Requests Inbox',
        url: 'su/me'
      };
    }

    if (errorStatusCode === 404) {
      return {
        header: "Oops! We couldn't find the page you're looking for.",
        subheader: "Let's get you back to safety.",
        buttonText: 'Go to Requests Inbox',
        url: 'su/me'
      };
    }

    if (errorStatusCode === 503) {
      return {
        header: 'There has been an error.',
        subheader: 'Please try reloading the page. If the issue persists please contact customer support.',
        buttonText: null,
        url: null
      };
    }

    return {
      header: "Oops! We couldn't find the page you're looking for.",
      subheader: "Let's get you back to safety.",
      buttonText: 'Go to Requests Inbox',
      url: 'su/me'
    };
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
  }
}
